module.exports = __webpack_public_path__ + "img/register.fdc31e91.svg";